// MIDAS V3 — History empty state (Phase 5)
//
// Port of the empty-state card from history-page.jsx (lines 258-266). Renders
// when the user's filter + search zeroes the loaded thread list. Centered
// card, dashed border, palette-aware copy.
//
// Per spec — v3 styling, does NOT reuse v2's MidasHistoryEmptyV2 (which is
// Tailwind-class-based and references midas-bone-deep + midas-terracotta
// colours that are MachineID-palette-specific).
//
// No MUI, no @emotion, no `sx`, no `dt` tokens.
import React from "react";

interface MidasHistoryEmptyV3Props {
  title: string;
  body: string;
}

const MidasHistoryEmptyV3: React.FC<MidasHistoryEmptyV3Props> = ({
  title,
  body,
}) => {
  return (
    <div
      role="status"
      style={{
        textAlign: "center",
        padding: "48px 24px",
        color: "var(--midas-v3-muted)",
        background: "var(--midas-v3-card)",
        border: "1px dashed var(--midas-v3-border)",
        borderRadius: 12,
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 500,
          marginBottom: 4,
          color: "var(--midas-v3-ink-2)",
        }}
      >
        {title}
      </div>
      <div style={{ fontSize: 13 }}>{body}</div>
    </div>
  );
};

export default MidasHistoryEmptyV3;
